import { PlanCompensatorioTurnosModel } from './PlanCompensatorioTurnos.model';

export class PlanCompensatorioModel {
    idPlanCompensacion: number;
    nombrePlanCompensacion: string;
    fechaInicial: Date;
    fechaFinal: Date;
    estado: string;
    horasCompensacion: number;
    fechaInicialInscripcion: Date;
    fechaFinalInscripcion: Date;
    fechaFinalRepConsolidado: Date;
    fechaInicialAutorizacion: Date;
    fechaFinalAutorizacion: Date;
    observaciones: string;
    horarioDiario: string;
    horarioSabados: string;
    horarioMixto: string;
    listaTurnos: PlanCompensatorioTurnosModel[];
}
